import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

import MainLayout from '../../components/layout/main/main-layout';
import {
	fetchRidersByPartner,
	getRiderPayments,
} from '../../services/api/riders/riders';
import { formatNumber } from '../../utils/strings';
import RiderPaymentModal from '../../components/riders/rider-payment-modal';

const RiderPaymentsPage = () => {
	const [from, setFrom] = useState();
	const [to, setTo] = useState();
	const [loading, setLoading] = useState(false);
	const [payments, setPayments] = useState([]);
	const [riders, setRiders] = useState([]);
	const [ridersMap, setRidersMap] = useState({});
	const [openFormModal, setOpenFormModal] = useState(false);
	const business = useSelector(({ auth }) => auth.business);

	useEffect(() => {
		const fetchRiders = async () => {
			try {
				const response = await fetchRidersByPartner(business.id);
				setRiders(response);
				setRidersMap(response.reduce((acc, rider) => {
					acc[rider.id] = rider;
					return acc;
				}, {}));

				const fromString = moment().subtract(2, 'days').format('YYYY-MM-DD');
				const toString = moment().format('YYYY-MM-DD');
				setFrom(fromString);
				setTo(toString);
			} catch (error) {
				console.error('Error fetching riders:', error);
			}
		};
		fetchRiders();
	}, []);

	useEffect(() => {
		const fetchRiderPayments = async () => {
			try {
				setLoading(true);
				const newTo = moment(to).add(1, 'day').format('YYYY-MM-DD');
				const response = await getRiderPayments(business.id, from, newTo);
				setPayments(response ?? []);
			} catch (error) {
				console.error('Error fetching rider payments:', error);
			} finally {
				setLoading(false);
			}
		};

		fetchRiderPayments();
	}, [from, to]);

	const renderRiderPayment = (payment) => {
		const rider = ridersMap[payment.rider];
		const date = moment(payment._created)
			.format('DD/MM/YYYY HH:mm');
		return (
			<div
				key={payment.id}
				className="flex flex-col items-start justify-between md:items-center md:flex-row p-2 shadow-sm rounded-md"
			>
				<div className="flex flex-col">
					<p className="font-italic text-[11px] text-gray-500">{date}</p>
					<p className="font-bold text-[14px]">
						{rider?.name} {payment.amount < 0 ? 'ha recibido' : 'ha enviado'}{' '}
						<span className="text-green-500">
							${formatNumber(Math.abs(payment.amount))}
						</span>
					</p>
					<p className="text-[14px] font-bold text-gray-500">
						{payment.method}
					</p>
					<p className="text-[14px] font-bold text-gray-500">
						{payment.details}
					</p>
				</div>
			</div>
		);
	};

	return (
		<MainLayout>
			<div className="flex flex-wrap items-end gap-4 mb-6">
				<div>
					<label
						className="block text-sm font-medium text-gray-700 mb-1"
						htmlFor="from-date"
					>
						Desde
					</label>
					<input
						id="from-date"
						type="date"
						className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
						value={from || ''}
						onChange={(e) => setFrom(e.target.value)}
						max={to || ''}
					/>
				</div>
				<div>
					<label
						className="block text-sm font-medium text-gray-700 mb-1"
						htmlFor="to-date"
					>
						Hasta
					</label>
					<input
						id="to-date"
						type="date"
						className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
						value={to || ''}
						onChange={(e) => setTo(e.target.value)}
						min={from || ''}
					/>
				</div>
				<button
					type="button"
					className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 font-medium"
					disabled={loading || !from || !to}
					onClick={() => {
						setFrom(moment().subtract(2, 'days').format('YYYY-MM-DD'));
						setTo(moment().format('YYYY-MM-DD'));
					}}
				>
					Limpiar
				</button>
				<button
					type="button"
					className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 font-medium"
					disabled={loading || !from || !to}
					onClick={() => setOpenFormModal(true)}
				>
					Registrar pago
				</button>
			</div>
			{openFormModal && (
				<RiderPaymentModal
					isOpen={openFormModal}
					riders={riders}
					onClose={() => setOpenFormModal(false)}
				/>
			)}
			<div className="flex flex-col gap-4">
				{payments.map((payment) => renderRiderPayment(payment))}
			</div>
		</MainLayout>
	);
};

export default RiderPaymentsPage;
